import { ITaxonomyTerm, IUserOrganization } from 'core/models';

interface IArgs {
  organization: IUserOrganization;
  terms: ITaxonomyTerm[];
}

export const filterTaxonomyByIsJa = (isJa: boolean, terms: ITaxonomyTerm[]): ITaxonomyTerm[] => {
  // Null check.
  if (!terms || terms.length === 0) return [];

  // Filter taxonomy terms based on JA status (nonJA = 1, JA = 2, both = 3)
  if (isJa) {
    return terms.filter(
      ({ metadataNumber }: ITaxonomyTerm) => metadataNumber === 2 || metadataNumber === 3 || !metadataNumber,
    );
  }

  return terms.filter(
    ({ metadataNumber }: ITaxonomyTerm) => metadataNumber === 1 || metadataNumber === 3 || !metadataNumber,
  );
};

/**
 * @function filterTaxonomyByOrg
 * @param organization
 * @param terms
 * @returns ITaxonomyTerm[]
 *
 * @description - A helper function that returns the correct terms by looking at the metadataNumber
 *                based on if the activity is JA or not by looking at the organization.
 *                - isJA: 1 or 3
 *                - nonJA: 2 or 3
 */
export const filterTaxonomyByOrg = ({ organization, terms }: IArgs): ITaxonomyTerm[] => {
  return filterTaxonomyByIsJa(organization.isJa, terms);
};
